import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon, MapPinIcon, GlobeIcon, InstagramIcon } from 'lucide-react';
import { business, images } from '../data/business';
import { services } from '../data/services';
export function Footer() {
  return <footer className="border-t border-line bg-ink text-white" data-id="element-34" data-mp="32m1d94cmxar9">
      <div className="mx-auto max-w-shell px-6 py-14" data-id="element-35" data-mp="36pzblcu4yhj9">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4" data-id="element-36" data-mp="3ufa64ckw7foy">
          <div data-id="element-37" data-mp="3ucxmzw3eezab">
            <img src={images.logo} alt="Logo van Goelst International B.V." className="h-9 w-auto bg-white p-1" width={160} height={36} data-id="element-38" data-mp="38qu4u3bljp2" />
            <p className="mt-5 max-w-xs text-[15px] leading-relaxed text-white/70" data-id="element-39" data-mp="3qcx9cdo4is4b">
              Ontwikkeling en productie van gordijnrailsystemen voor professionele projecten in hospitality,
              healthcare, architectuur en high-end residential. Gevestigd in Amersfoort, actief in Nederland en
              wereldwijd.
            </p>
            <a href={business.instagram} target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-2 text-[15px] text-white/80 transition-colors hover:text-accent" data-id="element-40" data-mp="3l9shh1e8ymmw">
              <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-41" data-mp="3q8dgwylod2aa" />
              {business.instagramLabel}
            </a>
          </div>

          <nav aria-label="Gordijnrails in het footermenu" data-id="element-42" data-mp="80xjc6sbqxik">
            <h2 className="font-display text-sm font-600 uppercase tracking-[0.18em] text-white/50" data-id="element-43" data-mp="32w2lsidfaa9">Gordijnrails</h2>
            <ul className="mt-5 space-y-3 text-[15px]" data-id="element-44" data-mp="hsabkzi1bpp4">
              {services.map(service => <li key={service.id} data-id="element-45" data-mp="cu8s4dgp5od4">
                  <Link to={`/diensten#${service.id}`} className="text-white/80 transition-colors hover:text-accent" data-id="element-46" data-mp="qthyymj0j64f">
                    {service.title}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <nav aria-label="Pagina's in het footermenu" data-id="element-47" data-mp="yty1bvsfwx5p">
            <h2 className="font-display text-sm font-600 uppercase tracking-[0.18em] text-white/50" data-id="element-48" data-mp="yupnyh427kju">Informatie</h2>
            <ul className="mt-5 space-y-3 text-[15px]" data-id="element-49" data-mp="13r7of4scwwqd">
              <li data-id="element-50" data-mp="18l2ecpyk27xw"><Link to="/" className="text-white/80 transition-colors hover:text-accent" data-id="element-51" data-mp="18l2csliwpzvs">Home</Link></li>
              <li data-id="element-52" data-mp="1ckt02f985xvk"><Link to="/over-ons" className="text-white/80 transition-colors hover:text-accent" data-id="element-53" data-mp="1ckt1mjovi5xo">Over Goelst International</Link></li>
              <li data-id="element-54" data-mp="1hmidu2nu0pnc"><Link to="/diensten" className="text-white/80 transition-colors hover:text-accent" data-id="element-55" data-mp="1hmife73hcxpg">Onze gordijnrailsystemen</Link></li>
              <li data-id="element-56" data-mp="1rj4yaqc8xeou"><Link to="/resources" className="text-white/80 transition-colors hover:text-accent" data-id="element-57" data-mp="1rj4zuurw9mqy">Resources & vermeldingen</Link></li>
              <li data-id="element-58" data-mp="3ocq1xuroio41"><Link to="/contact" className="text-white/80 transition-colors hover:text-accent" data-id="element-59" data-mp="3oczqddx2sn7m">Contact & route</Link></li>
              <li data-id="element-60" data-mp="3tc2umw58epej">
                <a href={business.website} target="_blank" rel="noopener" className="text-white/80 transition-colors hover:text-accent" data-id="element-61" data-mp="2aevh21mn04a0">
                  Officiële website
                </a>
              </li>
            </ul>
          </nav>

          <div data-id="element-62" data-mp="1wp0b7cj39y0i">
            <h2 className="font-display text-sm font-600 uppercase tracking-[0.18em] text-white/50" data-id="element-63" data-mp="1wpa0exwb8155">Contactgegevens</h2>
            <ul className="mt-5 space-y-4 text-[15px] text-white/80" data-id="element-64" data-mp="2tbn5sqky7blg">
              <li className="flex gap-3" data-id="element-65" data-mp="2pcw6cct0fhv6">
                <MapPinIcon className="mt-1 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-66" data-mp="2kdb5fwua4zft" />
                <span data-id="element-67" data-mp="2fe6yzdyqpft6">
                  {business.address.street}
                  <br data-id="element-68" data-mp="2fdyk5gj240fc" />
                  {business.address.postalCode} {business.address.city}
                  <br data-id="element-69" data-mp="18zpfwakicvtr" />
                  {business.address.region}, {business.address.country}
                </span>
              </li>
              <li className="flex gap-3" data-id="element-70" data-mp="2rvra3mqob2j1">
                <PhoneIcon className="mt-1 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-71" data-mp="2ruofp4u56hyd" />
                <a href={`tel:${business.phoneLink}`} className="transition-colors hover:text-accent" data-id="element-72" data-mp="2wnhllw1cjwc1">
                  {business.phoneDisplay}
                </a>
              </li>
              <li className="flex gap-3" data-id="element-73" data-mp="2ntmdqg8ubrsp">
                <MailIcon className="mt-1 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-74" data-mp="2nue1x603yn8y" />
                <a href={`mailto:${business.email}`} className="transition-colors hover:text-accent" data-id="element-75" data-mp="3bk8c1ft1lxpi">
                  {business.email}
                </a>
              </li>
              <li className="flex gap-3" data-id="element-76" data-mp="31khhxf8e9kpy">
                <GlobeIcon className="mt-1 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-77" data-mp="31nn68s978ikm" />
                <a href={business.website} target="_blank" rel="noopener" className="transition-colors hover:text-accent" data-id="element-78" data-mp="36mqd8i8qoyv8">
                  {business.websiteLabel}
                </a>
              </li>
            </ul>
            <p className="mt-5 text-[15px] text-white/60" data-id="element-79" data-mp="1nnsghwj2hz4u">
              Ma t/m vr 09:00 – 18:00
              <br data-id="element-80" data-mp="1ioz4y9ncci7b" />
              Zaterdag en zondag gesloten
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-81" data-mp="1rnjcqfrd57gr">
        <div className="mx-auto flex max-w-shell flex-col gap-2 px-6 py-6 text-[13px] text-white/50 sm:flex-row sm:items-center sm:justify-between" data-id="element-82" data-mp="1roueyb55u75r">
          <p data-id="element-83" data-mp="zwd75jsvihk3">© {new Date().getFullYear()} {business.name} — KVK {business.kvk}</p>
          <p data-id="element-84" data-mp="zuk0i4i9fxc3">{business.address.street}, {business.address.postalCode} {business.address.city}, {business.address.country}</p>
        </div>
      </div>
    </footer>;
}